import React from 'react';
import { NationalityFormItem } from '../../../components/auth/NationalityFormItem';
import { SubjectsFormItem } from '../../../components/auth/SubjectsFormItem';
import { FORM_TYPES_KEYS } from '../../../constants/Auth';
var getTitleAndItems = function (authType) {
    var title = '';
    var additionalItems = null;
    switch (authType) {
        case FORM_TYPES_KEYS.EMAIL:
            title = 'Last step';
            additionalItems = (React.createElement(React.Fragment, null,
                React.createElement(NationalityFormItem, null),
                React.createElement(SubjectsFormItem, null)));
            break;
        default:
            return null;
    }
    return (React.createElement("div", { className: "[&>.ant-form-item]:mb-4" },
        React.createElement("p", { className: "text-reading-base font-semibold mb-4 md:text-header-sm md:mb-8" }, title),
        additionalItems));
};
export var SecondStep = function (_a) {
    var authType = _a.authType;
    return getTitleAndItems(authType);
};
